import createClient, { type Middleware } from "openapi-fetch";
import type { paths } from "./types";

// Two deployment shapes:
//   1. Same-origin (dev or prod-as-mounted-static): the admin runs at
//      `<API>/admin/*` (or via the dev-mode vite `/api` proxy), so a
//      relative `baseUrl: ""` and `/api/v1/...` calls resolve correctly.
//   2. Split-origin (staging — admin.staging.2oodles.app calling
//      api.staging.2oodles.app): need an absolute baseUrl. `VITE_API_URL`
//      is read at build time and stamped into the bundle.
// Trailing slashes are stripped so `${baseUrl}/api/v1/...` always builds
// a clean URL.
export const BASE_URL = (import.meta.env.VITE_API_URL ?? "").replace(/\/+$/, "");

export const api = createClient<paths>({ baseUrl: BASE_URL });

let _accessToken: string | null = null;
let _refreshToken: string | null = null;

export function getAccessToken(): string | null {
  return _accessToken;
}

export function getRefreshToken(): string | null {
  return _refreshToken;
}

export function setTokens(access: string | null, refresh: string | null) {
  _accessToken = access;
  _refreshToken = refresh;
  if (refresh === null) {
    localStorage.removeItem("admin_refresh");
  } else {
    // Refresh stored in localStorage so the SPA survives reload without
    // forcing a fresh sign-in. The mobile/native side does the same. A
    // future hardening pass moves this to an HttpOnly cookie.
    localStorage.setItem("admin_refresh", refresh);
  }
}

export function loadStoredRefresh(): string | null {
  const stored = localStorage.getItem("admin_refresh");
  _refreshToken = stored;
  return stored;
}

const authMiddleware: Middleware = {
  async onRequest({ request }) {
    if (_accessToken) {
      request.headers.set("Authorization", `Bearer ${_accessToken}`);
    }
    return request;
  },
};

api.use(authMiddleware);
